import { useContext, useState } from "react";
import { Avatar, Box, Chip } from "@mui/material";
import { LanguageContext } from "../../context/LanguageContext";
import { statusColors } from "../../constants/statusColors";

// Copie de getActionStyle depuis TicketLine pour le statut

const statusKeyMap = {
  Open: "Open",
  "Working on It": "WorkingOnIt",
  "In Staging": "InStaging",
  "In Test": "InTest",
  "In Production": "InProduction",
  "In review": "InReview",
  Closed: "Closed",
};

export default function TicketLineAdmin({
  ticket,
  projectName,
  onEdit,
  onDelete,
  creator,
}) {
  const [hover, setHover] = useState(false);
  const { translate } = useContext(LanguageContext);

  // const { text: statusColor, background: statusBg } = getActionStyle(
  //   `Statut → ${ticket.status}`
  // );
  const statusBg = statusColors[ticket.status] || "#343a40";
  const statusColor = "#ffffff";

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => onEdit && onEdit(ticket)}
      sx={{
        display: "flex",
        flexDirection: "row", // ✅ important pour forcer l'horizontale
        alignItems: "center",
        cursor: "pointer",
        bgcolor: hover ? "action.hover" : "background.paper",
        borderRadius: "10px",
        mt: "10px",
        border: 1,
        borderColor: "divider",
      }}
    >
      <div
        style={{
          width: "13%",
          // padding: "15px 5px",
          // borderRight: "1px solid lightgrey",
          borderRight: 1,
          borderColor: "divider",
          alignItems: "center",
          textAlign: "center",
          justifyContent: "center",
          alignContent: "center",
          fontSize: 12,
          fontWeight: 500,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          display: "inline-block",
          // paddingLeft: "10px",
          // paddingRight: "5px",
        }}
      >
        <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
          {projectName}
        </div>
      </div>

      <div
        style={{
          width: "13%",
          // padding: "15px 5px",
          paddingTop: "15px",
          paddingBottom: "15px",
          borderRight: "1px solid lightgrey",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: "10px",
        }}
      >
        <Avatar src={creator.photoUrl} sx={{ width: 24, height: 24, mr: 1 }} />
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            flex: 1, // prend tout l’espace restant
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            display: "inline-block",
          }}
        >
          {creator.email}
        </span>
      </div>

      <div
        style={{
          width: "8%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          fontWeight: 500,
        }}
      >
        <div
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          {ticket.ticketNumber}
        </div>
      </div>

      {/* Ticket Name */}
      <div
        style={{
          width: "26%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          borderRight: "1px solid lightgrey",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontWeight: 500,
          minWidth: 0,
          flexShrink: 1,
        }}
      >
        <div
          style={{
            paddingLeft: "10px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ticket.ticketName}
        </div>
      </div>

      {/* Type */}
      <div
        style={{
          width: "10%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
        }}
      >
        {ticket.ticketType}
      </div>

      <div
        style={{
          width: "10%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          padding: "0 8px",
          boxSizing: "border-box",
        }}
      >
        <Chip
          icon={
            <Box
              component="span"
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor:
                  ticket.priority === "High"
                    ? "red"
                    : ticket.priority === "Medium"
                    ? "#ffc107"
                    : "#28a745",
              }}
            />
          }
          label={translate(ticket.priority)}
          sx={{
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.875rem",
            fontWeight: 500,
            background:
              ticket.priority === "High"
                ? "#f8d7da"
                : ticket.priority === "Medium"
                ? "#fff3cd"
                : "#d4edda",
            color:
              ticket.priority === "High"
                ? "red"
                : ticket.priority === "Medium"
                ? "#856404"
                : "#155724",
          }}
        />
      </div>

      <div
        style={{
          width: "8%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: "1px solid lightgrey",
          padding: "0 8px",
          boxSizing: "border-box",
        }}
      >
        <Chip
          // label={ticket.status}
          label={translate(statusKeyMap[ticket.status] || ticket.status)}
          sx={{
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.875rem",
            fontWeight: 500,
            bgcolor: statusBg,
            color: statusColor,
          }}
        />
      </div>

      {/* Created At */}
      <div
        style={{
          width: "12%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          fontSize: "12px",
        }}
      >
        {new Date(ticket.createdAt.seconds * 1000).toLocaleString()}
      </div>
    </Box>
  );
}
